import { render, staticRenderFns } from "./document-set.vue?vue&type=template&id=a4dad7b6&scoped=true"
import script from "./document-set.vue?vue&type=script&setup=true&lang=js"
export * from "./document-set.vue?vue&type=script&setup=true&lang=js"
import style0 from "./document-set.vue?vue&type=style&index=0&id=a4dad7b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dad7b6",
  null
  
)

export default component.exports